import { GenericFailure } from '@playq/services-shared';
import { CheckFilesBatchResponse } from '@playq/octopus2-files';
import { AppID } from '@playq/octopus-common';
import { PermModule } from '@playq/octopus2-auth';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { useModulePermissions } from '/hooks';

import { UseCheckFilesBatchType } from '../filesService/useCheckFilesBatch';

const emptyArray: [] = [];

export const useCheckAssetsBatch: UseCheckFilesBatchType = (
  { appID, batch },
  options?: IUseQueryOptionsExtended<CheckFilesBatchResponse | undefined, GenericFailure | Error>
) => {
  const keys = ['appAssetsService', 'checkFilesBatch', ...batch.map((f) => f.serialize())];

  const { canRead } = useModulePermissions(PermModule.UserAcquisitionCreativeAssets);

  const enabled = canRead && options?.enabled !== false && batch !== undefined && !!appID;

  const res = useEitherQuery(keys, () => services2.appAssetsService.checkFilesBatch(appID as AppID, batch), {
    ...options,
    enabled,
  });

  return {
    ...res,
    checkedFiles: res.data?.batch ?? emptyArray,
  };
};
